/** Owner-verified FloatHelm location number and public URL ID.
 * These are legacy *public URL identifiers*, never internal database UUIDs. */
export const bookingLocations={
  WC:{number:1,publicId:1202442},
  YD:{number:2,publicId:1204233},
  PR:{number:3,publicId:1204234},
} as const;
export type BookingLocationCode=keyof typeof bookingLocations;
export function locationCodeForBookingId(value:string|null):BookingLocationCode|null{
  for(const [code,info] of Object.entries(bookingLocations))
    if(String(info.publicId)===value)return code as BookingLocationCode;
  return null;
}
export function bookingPath(code:string,date:string){
  const info=bookingLocations[code as BookingLocationCode];
  if(!info)throw RangeError('Unknown booking location');
  if(!/^\d{4}-\d{2}-\d{2}$/.test(date))throw RangeError('Invalid booking date');
  return '/booking/'+date.replaceAll('-','/')+'?location='+info.publicId;
}
export function dateFromBookingPath(path:string):string|null{
  const match=/^\/booking\/(\d{4})\/(\d{2})\/(\d{2})$/.exec(path);
  return match?match[1]+'-'+match[2]+'-'+match[3]:null;
}
export function todayAtLocation(timezone:string){
  const parts=new Intl.DateTimeFormat('en-CA',{timeZone:timezone,
    year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
  const read=(type:string)=>parts.find(p=>p.type===type)?.value??'';
  return read('year')+'-'+read('month')+'-'+read('day');
}
